// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../constant/api";

// function BannerApprovalView() {
//     const [products, setProducts] = useState([]);
//     const [banner, setBanner] = useState({});
//     const token = localStorage.getItem("token");
  
//     // Fetch products on component load
//     useEffect(() => {
//       const fetchProducts = async () => {
//         try {
//           const response = await axios.get(`${BASE_URL}/products/`, {
//             headers: { Authorization: `Token ${token}` },
//           });
//           if (response.data?.Data) {
//             setProducts(response.data.Data);
//           }
//         } catch (error) {
//           console.error("Error fetching products:", error.message || error);
//         }
//       };
//       fetchProducts();
//     }, [token]);
  
//     return (
//       <div>
//         <div className="border-2 rounded-lg shadow-lg bg-gray-50 mt-10 p-6">
//           <h2 className="text-green-700 text-3xl font-bold text-center mb-6">
//             Banner Details
//           </h2>
//           <div className="flex flex-col gap-6 mb-6 w-full sm:flex-row sm:gap-8 sm:mb-8">
//             <div className="w-full sm:w-1/2">
//               <label className="text-gray-700 font-medium mb-2 block">Banner Image</label>
//               <div className="border rounded-md">
//                 {banner.banner_image ? (
//                   <img
//                     src={URL.createObjectURL(banner.banner_image)}
//                     alt="Banner Preview"
//                     className="w-full h-44 object-cover rounded-md mb-4"
//                   />
//                 ) : (
//                   <div className="w-full h-40 bg-gray-100 flex items-center justify-center rounded-md text-gray-500 mb-4">
//                     No Image Available
//                   </div>
//                 )}
//               </div>
//             </div>
  
//             <div className="w-full sm:w-1/2">
//               <div>
//                 <label className="text-gray-700 font-medium mb-2 block">Banner Name</label>
//                 <p className="text-lg text-gray-800">{banner.title || "N/A"}</p>
//               </div>
//               <div>
//                 <label className="text-gray-700 font-medium mb-2 block">Start Date</label>
//                 <p className="text-lg text-gray-800">{banner.start_date || "N/A"}</p>
//               </div>
//               <div>
//                 <label className="text-gray-700 font-medium mb-2 block">End Date</label>
//                 <p className="text-lg text-gray-800">{banner.end_date || "N/A"}</p>
//               </div>
//             </div>
//           </div>
//         </div>
  
//         <div className="mt-6">
//           <h2 className="text-xl font-bold mb-4">Products</h2>
//           <div className="overflow-x-auto">
//             <table className="w-full text-left">
//               <thead>
//                 <tr>
//                   <th className="py-2 px-2 text-green-500 text-sm font-bold">Item No</th>
//                   <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Code</th>
//                   <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Name</th>
//                   <th className="py-2 px-2 text-green-500 text-sm font-bold">Stock</th>
//                   <th className="py-2 px-2 text-green-500 text-sm font-bold">Price</th>
//                   <th className="py-2 px-2 text-green-500 text-sm font-bold">Image</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {products.map((product, index) => (
//                   <tr key={product.id}>
//                     <td className="py-2 px-2 ">
//                         <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">{index + 1}</div></td>
//                     <td className="py-2 px-2 ">
//                     <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">{product.code} </div></td>
//                     <td className="py-2 px-2 ">
//                     <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">{product.name} </div></td>
//                     <td className="py-2 px-2 ">
//                     <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">{product.stock} </div></td>
//                     <td className="py-2 px-2 ">
//                     <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">{product.price} </div></td>
//                     <td className="py-2 px-2 ">
//                       <img
//                         src={product.image || "https://via.placeholder.com/100"}
//                         alt={product.name}
//                         className="w-28 h-20 object-cover rounded"
//                       />
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

// export default BannerApprovalView


import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useParams } from "react-router-dom";

function BannerApprovalView() {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [banner, setBanner] = useState({});

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await USER_URL.get(`/products/admin/banners/${id}/`);
        
        // Extracting banner and products properly
        if (response.data?.Data) {
          const { banner, products } = response.data.Data;

          setBanner(banner || {});
          setProducts(Array.isArray(products) ? products : []);
        }
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
      }
    };
    
    fetchProducts();
  }, [id]);

  return (
    <div>
      <div className="border-2 rounded-lg shadow-lg bg-gray-50 mt-10 p-6">
        <h2 className="text-green-700 text-3xl font-bold text-center mb-6">
          Banner Details
        </h2>

        <div className="flex flex-col gap-6 mb-6 w-full sm:flex-row sm:gap-8 sm:mb-8">
          <div className="w-full sm:w-1/2">
            <label className="text-gray-700 font-medium mb-2 block">Banner Image</label>
            <div className="border rounded-md">
              {banner.banner ? (
                <img
                src={
                  banner.banner instanceof File
                    ? URL.createObjectURL(banner.banner) // Show selected logo file
                    : `${BASE_URL}${banner.banner}` // Show logo from API
                }
                  alt="Banner"
                  className="w-full h-44 object-cover rounded-md mb-4"
                />
              ) : (
                <div className="w-full h-40 bg-gray-100 flex items-center justify-center rounded-md text-gray-500 mb-4">
                  No Image Available
                </div>
              )}
            </div>
          </div>

          <div className="w-full sm:w-1/2">
          <div>
             <div className="p-4 bg-white border rounded-lg shadow-sm mb-4">
               <span className="block text-sm font-medium text-gray-600 mb-1">Banner Title</span>
               <p className="text-lg font-semibold text-gray-800">{banner.title || "No Title"}</p>
             </div>
 
             <div className="p-4 bg-white border rounded-lg shadow-sm mb-4">
               <span className="block text-sm font-medium text-gray-600 mb-1">Start Date</span>
               <p className="text-lg font-semibold text-gray-800">{banner.start_date || "yyyy/mm/dd"}</p>
             </div>
 
             <div className="p-4 bg-white border rounded-lg shadow-sm">
               <span className="block text-sm font-medium text-gray-600 mb-1">End Date</span>
               <p className="text-lg font-semibold text-gray-800">{banner.end_date || "yyyy/mm/dd"}</p>
             </div>
           </div>
            </div>
        </div>
      </div>

      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Products</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr>
                <th className="py-2 px-2 text-green-500 text-sm font-bold">Item No</th>
                <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Code</th>
                <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Name</th>
                <th className="py-2 px-2 text-green-500 text-sm font-bold">Stock</th>
                <th className="py-2 px-2 text-green-500 text-sm font-bold">Price</th>
                <th className="py-2 px-2 text-green-500 text-sm font-bold">Image</th>
              </tr>
            </thead>
            <tbody>
              {products.length > 0 ? (
                products.map((product, idx) => (
                  <tr key={product.id}>
                                         <td className="py-2 px-2">
                                           <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                                             {idx + 1}
                                           </div>
                                         </td>
                   
                                         <td className="py-2 px-2">
                                           <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                                             {product.product_code || "N/A"}
                                           </div>
                                         </td>
                   
                                         <td className="py-2 px-2">
                                           <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                                             {product.product_name || "N/A"}
                                           </div>
                                         </td>
                   
                                         <td className="py-2 px-2">
                                           <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                                             {product.stock || "N/A"}
                                           </div>
                                         </td>
                   
                                         <td className="py-2 px-2">
                                           <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                                             {product.price || "N/A"}
                                           </div>
                                         </td>
                   
                                         <td className="py-2 px-2">
                                           {product.product_banner_image ? (
                                             <img
                                             src={
                                               product.product_banner_image instanceof File
                                                 ? URL.createObjectURL(product.product_banner_image) // Show selected logo file
                                                 : `${BASE_URL}${product.product_banner_image}` // Show logo from API
                                             }
                                               alt={product.name || "Product Image"}
                                               className="w-28 h-20 object-cover rounded"
                                             />
                                           ) : (
                                             <div className="w-28 h-20 flex items-center justify-center border border-gray-300 rounded bg-gray-100">
                                               <span className="text-xs text-gray-500">No Image</span>
                                             </div>
                                           )}
                                         </td>
                                       </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-gray-500">
                    No products available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default BannerApprovalView;
